// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__17s9n","options":"AnswerScale_options__6RnWo","selected":"AnswerScale_selected__1J9V2"};